export default "__VITE_ASSET__CvmVGpNj__"